module.exports = __webpack_public_path__ + "img/ndibe.42508b63.png";